<template>
  <div  class="flex flex-col transform hover:scale-105 items-center text-grey">
    <label :for="id" class="cursor-pointer text-center font-semibold " :class="{'text-dark': checked}">
      <feather-icon v-if="icon" class="font-semibold" :icon="icon" stroke-width="3" svgClasses="h-5 w-5"/>
      <p>{{title}}</p>
    </label>
    <div class="flex justify-center text-center">
      <vs-radio :name="`${namespace}-checkbox`" :key="`${namespace}-radio`" v-if="singleSelect" class="hidden" color="dark" :id="id" v-model="innerModel" :vs-value="initValue"/>
      <vs-checkbox :name="`${namespace}-checkbox`" :key="`${namespace}-checkbox`" v-else class="hidden" color="dark" :id="id" v-model="innerModel" :vs-value="initValue"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  components: {
  },
  props: [
    'value',
    'title',
    'icon',
    'initValue',
    'singleSelect',
    'namespace',
  ],
  data () {
    return {
      innerModel: [],
    }
  },
  watch: {
    'namespace': {
      immediate: true,
      handler (value) {
        console.log("emitting from checkbox", value)
      }
    },
    'value': {
      immediate: true,
      handler (value) {
        this.innerModel = value
      }
    },
    'innerModel': {
      immediate: false,
      handler (value) {
        this.$emit('input', value)
      }
    },
  },
  computed: {
    id () {
      return _.kebabCase(this.title) + this.namespace
    },
    checked () {
      return _.includes(this.innerModel, this.initValue)
    }
  },
  methods: {

  }
}

</script>
